export const FUNCTION_SYMBOL = '^^fn^^'
export const REGEXP_SYMBOL = '^^re^^'
